import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const ProductDetails = () => {
  const { id } = useParams();
  const [knife, setKnife] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`http://localhost:5000/api/knives/${id}`)
      .then((response) => {
        setKnife(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Knife not found");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="text-center">Loading...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  return (
    <div className="container mx-auto py-10">
      <div className="flex flex-col md:flex-row items-center gap-10">
        <img src={knife.image} alt={knife.name} className="w-80 h-80 object-cover rounded-lg shadow-lg" />
        <div>
          <h1 className="text-4xl font-bold">{knife.name}</h1>
          <p className="text-2xl text-gray-600 mt-2">${knife.price}</p>
          <p className="text-lg text-gray-700 mt-4">
            This is a high-quality Viking knife, perfect for collectors and outdoor enthusiasts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;